import { isBooleanInventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { getDifferencesBetweenConfigsReturn } from ".";

export function RenderBooleanChange(
  change: getDifferencesBetweenConfigsReturn
) {
  if (
    isBooleanInventoryListingConfig(change.oldValue) &&
    isBooleanInventoryListingConfig(change.newValue)
  ) {
    return (
      <li>
        <b>{change.config}</b> changed from{" "}
        <b>"{change.oldValue ? "On" : "Off"}"</b> to{" "}
        <b>"{change.newValue ? "On" : "Off"}"</b>
      </li>
    );
  }
  return null;
}
